import React from 'react';
import QueryTable from 'pages/Dashboard/pages/Fax/Overview/QueryTable';
import {
  ListQueryProps,
} from 'pages/Dashboard/pages/Fax/types';

export default function Overview(query: ListQueryProps) {
  return (
    <div className="relative flex flex-col flex-1 overflow-y-hidden">
      <div className="w-full h-full">
        <QueryTable {...query} />
      </div>
    </div>
  );
}
